export default {
  id: 'recovr.jobItemErrorQuickFilter',
  name: 'RecovR Job Item Error Quick Filter',
  matches: {
    use: 'filterBar',
    client: 'TableDataViewer',
    objectType: 'jobItem'
  },
  layout: {
    sort: 'aaaa'
  },
  handles: () => true,
  appearance: ({
    context
  }) => {
    return {
      name: `Errors (${context.clientProps.parentItem?.data?.numErrors || 0})`,
      checkStyle: 'toggle',
      checked: context.clientProps.show === 'errors'
    };
  },
  perform: ({
    context
  }) => {
    context?.clientProps?.filterToErrors?.();
  }
};